"use client";

import {TextUsStages, ThankYouStages} from "@/src/shared/const";
import {useTextUsModalStore} from "@/src/stores/useTextUsModalStore";
import {Modal} from "@mui/material";
import { FC, useEffect } from "react";
import {ContactDataStage} from "./ContactDataStage";
import {ThankYouStage} from "./ThankYouStage";
import {FormProvider, useForm} from "react-hook-form";
import { nowInKyiv } from "@/src/shared/utils/dateTime";
import { useSearchParams } from 'next/navigation'
import useMutableSearchParams from "@/src/hooks/useMutableSearchParams";

const WORKING_HOURS = {
    START: 9,
    FINISH: 18
}
export const TextUsModal: FC = () => {
    const searchParams = useSearchParams()
    const searchTextUs = searchParams.get('tu')
    const { isOpen, stage, setStage, reset, open } = useTextUsModalStore();
    const { setSearchParams } = useMutableSearchParams();

    const getThankStage = (): ThankYouStages => {
        const now = nowInKyiv();
        const dayOfWeek = now.weekday;
        const hour = now.hour;

        const isWeekday = dayOfWeek >= 1 && dayOfWeek <= 5;
        const isWorkingTime = hour >= WORKING_HOURS.START && hour < WORKING_HOURS.FINISH;

        return isWeekday && isWorkingTime ? TextUsStages.ThankYouWorkDays : TextUsStages.ThankYouWeekend;
    }

    const form = useForm()

    useEffect(() => {
      // open modal if query parameter is present
      if (searchTextUs === '1') {
        open();
        // delete query parameter from URL after opening modal
        // to prevent reopening modal after page refresh
        setSearchParams("tu", undefined, "replace");
      }
    }, [searchTextUs]);

    return (
        <FormProvider {...form}>
            <Modal
            open={isOpen}
            onClose={() => {
                reset();
            }}
            className={"max-md:z-opened-nav-drawer"}
            >
            <>
                {stage === TextUsStages.ContactData && (
                    <ContactDataStage
                        onClose={() => {
                            reset();
                        }}
                        onSend={() => {
                            setStage(getThankStage());
                        }}
                    />
                )}
                {[TextUsStages.ThankYouWeekend, TextUsStages.ThankYouWorkDays].includes(stage) && (
                    <ThankYouStage
                        type={stage as ThankYouStages}
                        onAccept={() => {
                            reset();
                        }}
                    />
                )}
            </>
            </Modal>
        </FormProvider>
    );
};
